import { Component, Emit, Prop, Provide, Ref, Vue } from 'vue-property-decorator'
import ConfigurationLocalAssaysAssaygroupsLaboratoryModalBasicForm
    from '@/modules/configurationModule/detail/local-assays/assaygroups-laboratory/components/modal-basic-form/configuration-local-assays-assaygroups-laboratory-modal-basic-form.vue'
import { BModal } from 'bootstrap-vue'
import {
    ConfigurationAssaygroupLaboratoryCreateRequest,
    ConfigurationAssaygroupLaboratoryPatchInBatchRequest,
    ConfigurationAssaygroupLaboratoryResponse
} from '@/modules/configurationModule/detail/local-assays/assaygroups-laboratory/services/configuration-assaygroup-laboratory/configuration-assaygroup-laboratory.dto'
import {
    ConfigurationLocalAssaysGroupsModalState,
    initialConfigurationLocalAssaysGroupsModalState
} from '@/modules/configurationModule/detail/local-assays/assaygroups-laboratory/components/modal/configuration-local-assays-assaygroups-laboratory-modal.model'

@Component({
    components: {
        ConfigurationLocalAssaysAssaygroupsLaboratoryModalBasicForm
    }
})
export default class ConfigurationLocalAssaysAssaygroupsLaboratoryModal extends Vue {
    @Ref() readonly assaygroupsLaboratoryModal!: BModal

    @Prop(String) readonly actionTitle!: string

    @Provide() externalValidator = this.$validator

    @Emit()
    create(): ConfigurationAssaygroupLaboratoryCreateRequest {
        return {
            assaygroupId: this.state.assaygroupLaboratory.assaygroup!.id,
            name: this.state.assaygroupLaboratory.name!
        }
    }

    @Emit()
    update(): ConfigurationAssaygroupLaboratoryPatchInBatchRequest {
        return {
            id: this.state.assaygroupLaboratory.id!,
            name: this.state.assaygroupLaboratory.name
        }
    }

    state: ConfigurationLocalAssaysGroupsModalState

    private get _updateMode(): boolean {
        return !!this.state.assaygroupLaboratory?.id
    }

    get modelValidated(): boolean {
        const hasErrors: boolean = this.errors.any()
        const isDirty: boolean = this.$_someFieldIsDirty(this.fields)
        return !hasErrors && isDirty
    }

    constructor() {
        super()
        this.state = initialConfigurationLocalAssaysGroupsModalState()
    }

    async show(assaygroupLaboratory?: ConfigurationAssaygroupLaboratoryResponse): Promise<void> {
        await this.$validator.reset()

        this.state = initialConfigurationLocalAssaysGroupsModalState()
        if (assaygroupLaboratory) {
            this.state.assaygroupLaboratory = { ...assaygroupLaboratory }
        }

        this.assaygroupsLaboratoryModal.show()
    }

    hide(): void {
        this.assaygroupsLaboratoryModal.hide()
    }

    async doAction(): Promise<void> {
        const valid = await this.$validator.validateAll()
        if (valid) {
            if (this.state.assaygroupLaboratory) {
                if (this._updateMode) {
                    this.update() // emits an event
                } else {
                    this.create() // emits an event
                }
            }

            this.hide()
        }
    }
}
